module.exports = __webpack_public_path__ + "img/logo.483f2fa6.svg";